var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { H3 } from "@irati/ui/src/Headings";
import { Hr } from "@irati/ui/src/Layout";
import Markdown from "@irati/ui/src/Markdown";
import { FormattedMessage } from "@irati/utils/lang";
var ImportantInfoUL = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 0;\n  margin-left: -8px;\n  padding-left: 12px;\n"], ["\n  margin-bottom: 0;\n  margin-left: -8px;\n  padding-left: 12px;\n"])));
var ImportantInfoLI = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  list-style-type: none;\n  margin: 5px 0 5px 0.8em;\n  &:before {\n    border-radius: 50%;\n    border: 3px solid #ff0000;\n    content: \"\";\n    height: 6px;\n    line-height: 18px;\n    margin-left: -16px;\n    position: absolute;\n    top: 40%;\n    width: 6px;\n  }\n  div,\n  p {\n    display: inline;\n  }\n"], ["\n  position: relative;\n  list-style-type: none;\n  margin: 5px 0 5px 0.8em;\n  &:before {\n    border-radius: 50%;\n    border: 3px solid #ff0000;\n    content: \"\";\n    height: 6px;\n    line-height: 18px;\n    margin-left: -16px;\n    position: absolute;\n    top: 40%;\n    width: 6px;\n  }\n  div,\n  p {\n    display: inline;\n  }\n"])));
var ImportantInfo = /** @class */ (function (_super) {
    __extends(ImportantInfo, _super);
    function ImportantInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImportantInfo.prototype.render = function () {
        var reward = this.props.reward;
        return (React.createElement("section", null,
            React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "reward.importantInfo.header" })),
            React.createElement(Hr, { small: true }),
            React.createElement(ImportantInfoUL, null, reward.importantInfo.map(function (info, index) { return (React.createElement(ImportantInfoLI, { key: index },
                React.createElement(Markdown, { key: index, source: info }))); }))));
    };
    return ImportantInfo;
}(PureComponent));
export default ImportantInfo;
var templateObject_1, templateObject_2;
